import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { SpinnerBlock } from "../common/Spinner";

import * as authSelectors from "../auth/authSelectors";
import { routes } from "../../appRoutingHelpers";
import { ProductAdditionsListRow } from "./ProductAdditionsListRow";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { PrimaryButton } from "../../components/Buttons";
import { Table } from "../../components/table-components/Table";
import { useGetAdditionGroups } from "../../service/api";
import { useHandleFetchError } from "../../error-handler";

interface Props {}

export const ProductAdditionsList: React.FC<Props> = (props) => {
  const organization = useSelector(authSelectors.selectedOrganizationKeyName);
  const navigate = useNavigate();

  const { data, isLoading, error } = useGetAdditionGroups(organization);

  useHandleFetchError(error);

  if (isLoading) {
    return <SpinnerBlock />;
  }

  return (
    <div className="container mt-7">
      <div className="row row-cards row-deck">
        <div className="col-12">
          <div className="card">
            <div className="card-header border-bottom-0 mt-4 mb-4 justify-content-between">
              <StyledText
                color={colors.textPrimary}
                className="bodyHeaderOneSemi card-title"
              >
                Addition groups list
              </StyledText>
              <PrimaryButton
                onClick={() =>
                  navigate(routes.shopProductAdditionsNew(organization))
                }
                backgroundColor={colors.ctaMain}
                hoverColor={colors.ctaSecondaryOne}
                color={colors.white}
              >
                Add new
              </PrimaryButton>
            </div>
            <div className="pl-5 pr-5">
              <Table>
                <thead>
                  <tr className="border-top">
                    <th className="pl-3">
                      <StyledText
                        className="bodySubtextRegular mb-0"
                        color={colors.textSecondary}
                      >
                        Admin name
                      </StyledText>
                    </th>
                    <th>
                      <StyledText
                        className="bodySubtextRegular mb-0"
                        color={colors.textSecondary}
                      >
                        Addition group name
                      </StyledText>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((pa) => {
                    return (
                      <ProductAdditionsListRow
                        key={pa.id}
                        productAddition={pa}
                      />
                    );
                  })}
                </tbody>
              </Table>
            </div>
            <div className="card-footer text-center mr-5 ml-5"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
